/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTheme } from 'emotion-theming';

import { Theme } from 'features/Theme';

import Button, { ButtonProps } from 'components/Button';
import React, { useCallback } from 'react';
import useFmcHost from 'hooks/useFmcHost';
import useTranslate from 'hooks/useTranslate';
import { applicationComplete } from 'fmc-sdk';

/**
 * Continue Button that appears in the embedded case
 */
type PropTypes = {
  onClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => Promise<void> | void;
} & Omit<ButtonProps, 'onClick'>;

const EmbeddedContinueButton: React.FC<PropTypes> = props => {
  const { children, onClick, ...rest } = props;
  const fmcDispatch = useFmcHost();
  const theme = useTheme<Theme>();
  const t = useTranslate();

  const handleClick = useCallback(
    async (event: React.MouseEvent<HTMLButtonElement>) => {
      if (onClick) {
        const result = onClick(event);
        if (result && 'then' in result) {
          await result;
        }
      }
      fmcDispatch(applicationComplete());
    },
    [fmcDispatch, onClick],
  );

  if (!theme.embedded) {
    return null;
  }

  return (
    <Button id="continue" variant="text" onClick={handleClick} {...rest}>
      {children || t('embeddedContinueButton')}
    </Button>
  );
};

export default EmbeddedContinueButton;
